interface ICreateArticleData {
    title: string;
    content: string;
}

export const NewCreateArticleData: ICreateArticleData = { title: "", content: "" };

export default ICreateArticleData;
